<template>
  <div class="content-map-container">
    <!-- 顶部：统计卡片组件 -->
    <div class="stats-section">
      <ContentMapNum />
    </div>
    
    <!-- 底部：地图展示区域 -->
    <div class="map-section">
      <div id="china-map" class="map-chart"></div>
      <!-- 如果已有地图组件，可以这样使用：
      <ChinaMap 
        id="china-map"
        :width="'100%'"
        :height="'100%'"
        :place="'china'"
        :path="mapPath"
        :params="mapParams"
      />
      -->
    </div>
  </div>
</template>

<script>
import ContentMapNum from './contentMapNum.vue'
// import ChinaMap from '@/components/Charts/ChinaMap.vue'

export default {
  name: 'ContentMap',
  components: {
    ContentMapNum,
    // ChinaMap
  },
  data() {
    return {
      mapChart: null,
      mapPath: '', // 地图数据接口路径
      mapParams: {} // 地图参数
    }
  },
  mounted() {
    this.initMap()
  },
  beforeDestroy() {
    if (this.mapChart) {
      this.mapChart.dispose()
      this.mapChart = null
    }
  },
  methods: {
    initMap() {
      // 这里可以初始化地图
      // 如果使用 ECharts 地图，可以这样初始化：
      // this.$nextTick(() => {
      //   const echarts = require('echarts')
      //   this.mapChart = echarts.init(document.getElementById('china-map'), 'dark')
      //   this.loadMapData()
      // })
      
      // 或者调用接口获取地图数据
      // this.loadMapData()
    },
    loadMapData() {
      // 加载地图数据的示例
      // this.$http.post(process.env.VUE_APP_API_HOST + "/map_data", {
      //   "extra_params": {}
      // }).then((res) => {
      //   if (res.data && res.data.data) {
      //     // 处理地图数据
      //     this.renderMap(res.data.data)
      //   }
      // })
    },
    renderMap(mapData) {
      console.log(mapData)
      // 渲染地图的示例
      // if (this.mapChart && mapData) {
      //   this.mapChart.setOption({
      //     // 地图配置选项
      //   })
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-map-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .stats-section {
    flex-shrink: 0;
    height: 120px; // 根据实际需求调整高度
    min-height: 120px;
    width: 100%;
  }

  .map-section {
    flex: 1;
    width: 100%;
    min-height: 0;
    position: relative;
    overflow: hidden;

    .map-chart {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

